import { RootState } from "apps/store";

export const getListUserCreateRaceSelector = (state: RootState) => state.userCreateRace.userCreateRace

export const loadingUserCreateRaceSelector = (state: RootState) => state.userCreateRace.loadingUserCreateRace

export const errorUserCreateRaceSelector = (state: RootState) => state.userCreateRace.errorUserCreateRace

export const userCreateRaceSuccessSelector = (state: RootState) => state.userCreateRace.userCreateRaceSuccess

export const getLimitRaceSelector = (state: RootState) => state.userCreateRace.limit

export const getFeeRaceSelector = (state: RootState) => state.userCreateRace.fee

export const errorFeeSelector = (state: RootState) => state.userCreateRace.errorFee

export const errorLimitSelector = (state: RootState) => state.userCreateRace.errorLimit

export const errorCancelUserCreateRaceSelector = (state: RootState) => state.userCreateRace.errorCancelUserCreateRace

export const loadingCancelUserCreateRaceSelector = (state: RootState) => state.userCreateRace.loadingCancelUserCreateRace

export const dataInputSelector = (state: RootState) => state.userCreateRace.dataInput

export const getCoinListTable = (state: RootState) => state.userCreateRace.coinListRes

export const errorCoinListTable = (state: RootState) => state.userCreateRace.errorCoin

export const getNftListTable = (state: RootState) => state.userCreateRace.nftListRes

export const errorNftListTable = (state: RootState) => state.userCreateRace.errorNft

export const getNonNftListTable = (state: RootState) => state.userCreateRace.nonNftRes

export const errorNonNftListTable = (state: RootState) => state.userCreateRace.errorNft

export const getTicketListTable = (state: RootState) => state.userCreateRace.ticketRes

export const errorTicketListTable = (state: RootState) => state.userCreateRace.errorTicket
